import React, { useState } from "react";
import { ReactComponent as GroupsIcon } from "../../assets/images/groups.svg";
import { ReactComponent as AddIcon } from "../../assets/images/addicon.svg";
import GroupDashboard from "./StatusCompletionComponent";
import CustomerGroupCounts from "./CustomerGroupCounts";
import StatusCompletionComponent from "./StatusCompletionComponent";
import NotesCard from "./NotesCard";
import CalenderEvent from "./CalenderEvent";
import CustomerDocument from "../customer/Documents/CustomerDocument";

const SpecificDashboard = () => {
  const [currentHashId, setCurrentHashId] = useState(window.location.hash.split("?")[1]);

  return (
    <div className="rounded-tl-[5px] rounded-tr-[5px] bg-white border border-D2DAE1 shadow-2 ">
      <div className="text-203C50 text-[22px] py-2 px-4 border-b border-D2DAE1">
        <span className="font-semibold">Dashboard - </span>
        <span className="font-normal">Group</span>
      </div>

      <div className="p-4">
        <div className="flex space-x-2">
          <div className="w-[654px] flex flex-col gap-2">
            <div className="shadow-13 border border-D2DAE1 rounded-[10px] ">
              <div className="border-b border-D2DAE1 py-2 px-4 text-203C50 text-lg font-semibold">General Info</div>

              <div className="flex py-2 px-4 border-b border-D2DAE1">
                <div>
                  <div className="flex items-center">
                    <span>
                      <GroupsIcon />
                    </span>
                    <span className="text-203C50 text-lg font-medium font-Vietnam ms-2">John Salvatier</span>
                  </div>
                  <div>
                    <span className="text-sm font-light text-F16136">Company Name Here</span>
                  </div>
                </div>
                <div className="ms-6">
                  <div>
                    <label className="text-sm font-light text-848687">Phone : </label>
                    <span className="text-sm text-2C495D">+91-917 211 2167</span>
                  </div>
                  <div>
                    <label className="text-sm font-light text-848687">Email : </label>
                    <span className="text-sm text-2C495D">Shashi.Raj@globalfpo.com</span>
                  </div>
                </div>
              </div>

              <div className="py-2 px-4 grid grid-cols-4 gap-2">
                <div>
                  <label className="block text-sm font-light text-848687">Cus. Display Name</label>
                  <span className="text-sm text-2C495D">John</span>
                </div>
                <div>
                  <label className="block text-sm font-light text-848687">Tax Number</label>
                  <span className="text-sm text-2C495D">115212541215212</span>
                </div>
                <div>
                  <label className="block text-sm font-light text-848687">Country</label>
                  <span className="text-sm text-2C495D">India</span>
                </div>
                <div>
                  <label className="block text-sm font-light text-848687">Business Category</label>
                  <span className="text-sm text-2C495D">Bookkeeper</span>
                </div>

                <div>
                  <label className="block text-sm font-light text-848687">Type</label>
                  <span className="text-sm text-2C495D">DATA</span>
                </div>
                <div>
                  <label className="block text-sm font-light text-848687">Customer Group</label>
                  <span className="text-sm text-2C495D">Business</span>
                </div>
                <div>
                  <label className="block text-sm font-light text-848687">Website</label>
                  <span className="text-sm text-2C495D">www.globalfpo.com</span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              <CustomerGroupCounts />

              <div className="shadow-13 rounded-[9.954px] border border-D2DAE1">
                <div className="flex justify-between border-b border-D2DAE1 py-2 px-4 ">
                  <span className="text-203C50 text-[17.918px] font-semibold">Services</span>
                  <span>
                    <AddIcon />
                  </span>
                </div>

                <div className="px-4">
                  <div className="flex justify-between py-3">
                    <label className="text-[#2C495D] text-sm font-medium">Tax</label>
                    <span className="text-[#2C495D] text-sm font-medium">45</span>
                  </div>

                  <div className="flex justify-between py-3">
                    <label className="text-[#2C495D] text-sm font-medium">Audit</label>
                    <span className="text-[#2C495D] text-sm font-medium">62</span>
                  </div>

                  <div className="flex justify-between py-3">
                    <label className="text-[#2C495D] text-sm font-medium">Bookkeeping</label>
                    <span className="text-[#2C495D] text-sm font-medium">15</span>
                  </div>

                  <div className="flex justify-between py-3">
                    <label className="text-[#2C495D] text-sm font-medium">Payroll</label>
                    <span className="text-[#2C495D] text-sm font-medium">20</span>
                  </div>

                  <div className="flex justify-between py-3">
                    <label className="text-[#2C495D] text-sm font-medium">Accounting</label>
                    <span className="text-[#2C495D] text-sm font-medium">16</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1">
              <div className="border border-D2DAE1 rounded-md">
                <div className="border-b border-D2DAE1 py-2 px-4  text-203C50 text-lg font-semibold">Recent Files</div>
                <div className="px-4">
                  <CustomerDocument />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-y-2">
            <GroupDashboard />
            <NotesCard />
          </div>
          <div>
            <CalenderEvent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecificDashboard;
